import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { useCloudPlatformDiscovery } from '../utils/hooks';
import { getDAILicenseMetadata } from './daiLicense.functions';
import type { DAILicenseMetadata } from './gen/ai/h2o/engine/v1/dai_license_pb';
import type { GetDAILicenseMetadataResponse } from './gen/ai/h2o/engine/v1/dai_license_service_pb';

export const cacheKeys = {
  daiLicenseMetadata: () => [`aiem`, `daiLicenseMetadata`] as const,
};

export const useQueryDAILicenseMetadata = <TData = DAILicenseMetadata>(
  options?: Omit<UseQueryOptions<DAILicenseMetadata, unknown, TData>, `queryKey` | `queryFn`>
) => {
  const cloudPlatformDiscovery = useCloudPlatformDiscovery();
  const aiemUrl = cloudPlatformDiscovery?.aiEngineManagerApiUrl || ``;

  const baseOptions: UseQueryOptions<DAILicenseMetadata, unknown, TData> = {
    queryKey: cacheKeys.daiLicenseMetadata(),
    queryFn: async ({ signal }) => {
      const response: GetDAILicenseMetadataResponse = await getDAILicenseMetadata(aiemUrl, {}, { signal });
      return response.daiLicenseMetadata!;
    },
  };

  return useQuery({ ...options, ...baseOptions });
};
